@if (event) {
    <div class="spotlight-details" (click)="navigate()">
        @if (imageUrl()) {
            <img class="spotlight-image" [src]="imageUrl()" />
        }
        <b>{{ event.Title }}</b>
        @if (event.Subtitle) {
            <div>{{ event.Subtitle }}</div>
        }
    </div>
}
